import { GET, RBAC_API } from '../constants';
import { jwtTokenHeader, request } from '../utils';

export async function getAllUsers() {
  return request(GET, `${RBAC_API}/v1/users`, {}, await jwtTokenHeader(), 'Failed to fetch Users');
}
